/**
 * PhaseBanner — transient phase-change inline banner (aria-live).
 *
 * Originally derived from the (removed) board-game-playground for visual parity. UI is NOT shared (CLAUDE.md).
 */

export interface PhaseBannerProps {
  readonly message: string | null;
  readonly variant?: "info" | "error";
}

export function PhaseBanner({ message, variant = "info" }: PhaseBannerProps) {
  if (!message) return null;

  const isError = variant === "error";
  return (
    <div
      data-testid="cascadia-phase-banner"
      aria-live="polite"
      role="status"
      style={{
        background: isError
          ? "var(--cn-cascadia-illegal-bg)"
          : "var(--cn-cascadia-phase-bg)",
        color: isError
          ? "var(--cn-cascadia-illegal)"
          : "var(--cn-cascadia-phase-text)",
        borderBottom: `1px solid ${isError ? "var(--cn-cascadia-illegal)" : "var(--cn-cascadia-phase-border)"}`,
        padding: "8px 16px",
        fontSize: 13,
        textAlign: "center",
      }}
    >
      {message}
    </div>
  );
}
